"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
  };
  return function (d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var BasePrinter = function (_super) {
  __extends(BasePrinter, _super);
  function BasePrinter(props) {
    var _this = _super.call(this, props) || this;
    var style = document.createElement("style");
    style.type = "text/css";
    style.innerHTML = "@media screen{\n        .print-wrapper{\n            display:none\n        }\n    }\n    @media print{\n        body *{\n            visibility:hidden\n        }\n        .print-wrapper,.print-wrapper *{\n            visibility:visible!important\n        }\n        .print-wrapper{\n            position:absolute;\n            left:0;\n            top:0;\n            width:100%;\n        }\n    }";
    _this._styleTag = document.head.appendChild(style);
    return _this;
  }
  BasePrinter.prototype.render = function () {
    return react_1.default.createElement("div", {
      className: "print-section"
    }, this._renderContent());
  };
  BasePrinter.prototype.componentDidCatch = function () {
    this._styleTag.remove();
    this.props.unMount();
  };
  BasePrinter.prototype.componentDidMount = function () {
    var _this = this;
    setTimeout(function () {
      window.print();
      _this._styleTag.remove();
      _this.props.unMount();
    }, 100);
  };
  return BasePrinter;
}(react_1.default.Component);
exports.BasePrinter = BasePrinter;